module.exports = "pegasus/assets/email1-header-4.png";